var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$i18.language("小易AI在线支付"),
            visible: _vm.dialogVisible,
            width: "504px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "chat-title" }, [
            _vm._v(
              _vm._s(_vm.$i18.language("请选择开通在线服务")) +
                " " +
                _vm._s(
                  _vm.$i18.language("(开通服务后公司所属账户都将获得 Pro 权益)")
                )
            ),
          ]),
          _c("table", { staticClass: "table-style" }, [
            _c("tr", [
              _c("th", [_vm._v("-")]),
              _c("th", [_vm._v(_vm._s(_vm.$i18.language("小易AIPro提问包")))]),
              _c("th", [_vm._v(_vm._s(_vm.$i18.language("普通体验版")))]),
            ]),
            _c("tr", [
              _c("td", [_vm._v(_vm._s(_vm.$i18.language("对话次数")))]),
              _c("td", { staticClass: "font-color" }, [
                _vm._v(_vm._s(_vm.tableData.Conversations)),
              ]),
              _c("td", [_vm._v(_vm._s(_vm.$i18.language("10次/天")))]),
            ]),
            _c("tr", [
              _c("td", [_vm._v(_vm._s(_vm.$i18.language("历史对话")))]),
              _c("td", { staticClass: "font-color" }, [
                _vm._v(_vm._s(_vm.tableData.Dialog)),
              ]),
              _c("td", [_vm._v(_vm._s(_vm.$i18.language("保留7天")))]),
            ]),
            _c("tr", [
              _c("td", [_vm._v(_vm._s(_vm.$i18.language("上下文能力")))]),
              _c("td", { staticClass: "font-color" }, [
                _vm._v(_vm._s(_vm.tableData.Context)),
              ]),
              _c("td", [_vm._v("-")]),
            ]),
            _c("tr", [
              _c("td", [_vm._v(_vm._s(_vm.$i18.language("价格")))]),
              _c("td", { staticClass: "font-color" }, [
                _vm._v(_vm._s(_vm.tableData.Price)),
              ]),
              _c("td", [_vm._v("-")]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "pay" },
            [
              _c(
                "el-button",
                {
                  staticClass: "confirm-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.payNow },
                },
                [_vm._v(_vm._s(_vm.$i18.language("立即支付")))]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "agreement" },
            [
              _c(
                "el-checkbox",
                {
                  staticClass: "xy-check",
                  attrs: { size: "mini" },
                  model: {
                    value: _vm.policyChecked,
                    callback: function ($$v) {
                      _vm.policyChecked = $$v
                    },
                    expression: "policyChecked",
                  },
                },
                [
                  _c("span", { staticStyle: { color: "#999999" } }, [
                    _vm._v(_vm._s(_vm.$i18.language("我已阅读并同意"))),
                  ]),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.enlangs
                          ? `${_vm.ePlatformUrl}policyEn.html`
                          : `${_vm.ePlatformUrl}policy.html`,
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$i18.language("《用户隐私政策》")))]
                  ),
                  _c("span", [_vm._v(_vm._s(_vm.$i18.language("和")))]),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.enlangs
                          ? `${_vm.ePlatformUrl}e_policyEn.html`
                          : `${_vm.ePlatformUrl}e_policy.html`,
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$i18.language("《服务条款》")))]
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c("chat-pay", {
        ref: "chatPay",
        attrs: { price: _vm.tableData.DiscountPrice },
        on: { chatTable: _vm.chatTable },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }